import AirportIcon from '@/assets/icons/airport-icon.svg'
import BusIcon from '@/assets/icons/bus-icon.svg'
import SubwayIcon from '@/assets/icons/subway-icon.svg'
import TrainIcon from '@/assets/icons/train-icon.svg'
import { AirportModel } from '../../types/models/airport.model'

const icons = {
  bus_station: <BusIcon />,
  airport: <AirportIcon />,
  subway_station: <SubwayIcon />,
  train_station: <TrainIcon />,
}

export const Place: React.FC<AirportModel> = ({ address, name, types }) => {
  const getIcon = () =>
    types.map(type => icons[type]).filter(Boolean)[0] || <SubwayIcon />

  return (
    <div className='flex items-center gap-2'>
      <span>{getIcon()}</span>
      <div className='flex flex-col gap-1'>
        <span className='text-sm font-medium'>{name || address}</span>
        <span className='text-grey-50 text-sm'>{address || name}</span>
      </div>
    </div>
  )
}
